import { render, staticRenderFns } from "./remittances.vue?vue&type=template&id=352de7d1&"
import script from "./remittances.vue?vue&type=script&lang=js&"
export * from "./remittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports